import {
  useFetchFieldsQuery,
  groupBySpeciesCategory,
  useFetchFieldSpeciesQuery,
} from '@/features/fieldSlice';
import { useSmallScreen } from '@/hooks/useWindowDimension';
import legendClasses from '@/views/map/MapLayerManager/MapLayerLegend.module.css';
import classes from './SpeciesLegend.module.css';

const formatSpeciesCategory = (str: string) => {
  const frags = str.split('_');
  frags[0] = frags[0].charAt(0).toUpperCase() + frags[0].slice(1);
  return frags.join(' ');
};

const isOtherCategory = (name: string) =>
  name.toLocaleLowerCase() === 'other deciduous' ||
  name.toLocaleLowerCase() === 'other evergreen';

export const SpeciesLegend = () => {
  const { data: fields } = useFetchFieldsQuery();
  const { data: speciesData } = useFetchFieldSpeciesQuery(undefined, {
    skip: !fields || !fields.map((i) => i.field).includes('species'),
  });

  const { speciesGroupedByCategory } = groupBySpeciesCategory(speciesData);
  const isSmallScreen = useSmallScreen();
  let species;

  if (speciesGroupedByCategory !== null) {
    species = Object.keys(speciesGroupedByCategory).map(
      (specieCategory, index) => (
        <div key={index}>
          {specieCategory !== 'other' && (
            <div className={classes.categoryTitle}>
              {formatSpeciesCategory(specieCategory)}
            </div>
          )}
          <ul className={classes.speciesList}>
            {speciesGroupedByCategory[specieCategory].map((specie, index) => {
              if (!specie.color) {
                return null;
              }
              const { r, g, b, a } = specie.color;
              const isOther = isOtherCategory(specie.name);
              return (
                <li key={index} className={classes.speciesListItem}>
                  <span
                    className={classes.indicator}
                    style={{
                      borderColor: `rgba(${r}, ${g}, ${b}, ${isOther ? 0 : a})`,
                      backgroundColor: `rgba(${r}, ${g}, ${b}, ${isOther ? 0.3 : 0.5})`,
                    }}
                  />
                  <span>{specie.name}</span>
                </li>
              );
            })}
          </ul>
        </div>
      )
    );
  }

  return (
    <div
      className={`${legendClasses.legend} ${classes.layout}`}
      data-testid="species-legend"
    >
      {!isSmallScreen && (
        <div className={legendClasses.legendTitle}>Tree cover by species</div>
      )}
      {species}
    </div>
  );
};
